import { makeAutoObservable, observable } from 'mobx';

import { MedicalCaseList } from '@store/models/SystemFields/MedicalCase';

import { TaskList } from './TaskList';

export type ParticipantsFieldNames = 'author' | 'requester' | 'actualExecutor';
export type DescriptionFieldNames = 'type' | 'description' | 'comment' | 'rejectionComment';
export type PatientDataFieldNames = 'patient' | 'entry';

export class TaskStore {
    public static Name = 'taskStore' as const;

    @observable public readonly taskList = new TaskList();
    @observable public readonly medicalCaseList = new MedicalCaseList();

    constructor() {
        makeAutoObservable(this);
    }
}

export const taskStore = new TaskStore();
